import { LAYOUT_HEADER_HEIGHT, LAYOUT_TAG_HEIGHT } from './constants';
let isDirect = (page) => [
    'message',
    'mailbox',
    'lxContact',
    'schedule',
    'disk',
    'setting',
    'worktable',
    'apps',
    'aiStaff',
    'aiTeam',
].includes(page);
let isIndirect = (page) => !isDirect(page);
const getMainContOffsetTopHeight = () => {
    return LAYOUT_HEADER_HEIGHT + LAYOUT_TAG_HEIGHT;
};
export { isDirect, isIndirect, getMainContOffsetTopHeight };
